import React from 'react';

import TickIcon from '../../../../assets/TickIcon.svg';

export const BenefitItem = ({ children }: { children: React.ReactNode }) => {
  return (
    <li className="flex items-center">
      <img src={TickIcon} alt="Tick icon" />
      <div className="ml-m gap-s text-m font-med">{children}</div>
    </li>
  );
};
